export const items = [
    {
      key: '1',
      label: 'Languages',
      children: (
        <div>
            <img src="https://img.shields.io/badge/Python-FFD43B?style=for-the-badge&logo=python&logoColor=blue" alt="badge" />
            <img src="https://img.shields.io/badge/JavaScript-323330?style=for-the-badge&logo=javascript&logoColor=F7DF1E" alt="javascript badge" />
            <img src="https://img.shields.io/badge/Java-ED8B00?style=for-the-badge&logo=java&logoColor=white" alt="badge" />
            <img src="https://img.shields.io/badge/C-blue?style=for-the-badge&logo=C" alt="typescript badge" />
            <img src="https://img.shields.io/badge/C%2B%2B-00599C?style=for-the-badge&logo=c%2B%2B&logoColor=white" alt="badge" />
            <img src="https://img.shields.io/badge/C%23-red?style=for-the-badge&logo=C%23" alt="badge" />
            <img src="https://img.shields.io/badge/typescript-%23007ACC.svg?style=for-the-badge&logo=typescript&logoColor=white" alt="typescript badge" />
            
        </div>
      ),
    },
    {
      key: '2',
      label: 'App Development Tech Stack',
      children: (
        <div>
            <img src="https://img.shields.io/badge/React-20232A?style=for-the-badge&logo=react&logoColor=61DAFB" alt="React_badge" />
            <img src="https://img.shields.io/badge/react_native-%2320232a.svg?style=for-the-badge&logo=react&logoColor=%2361DAFB" alt="ReactNative_badge" />
            <img src="https://img.shields.io/badge/Redux-593D88?style=for-the-badge&logo=redux&logoColor=white" alt="Redux_badge" />
            <img src="https://img.shields.io/badge/Redux%20Saga-red?style=for-the-badge&logo=redux%20saga" alt="saga_badge"/>
            <img src="https://img.shields.io/badge/Ant%20Design-1890FF?style=for-the-badge&logo=antdesign&logoColor=white" alt="Ant Design_badge" />
            <img src="https://img.shields.io/badge/Styled%20Components-yellow?style=for-the-badge&logo=Styled%20Components" alt="StyledComponents_badge"/>
            <img src="https://img.shields.io/badge/NPM-orange?style=for-the-badge&logo=npm" alt="npm"/>
            
        </div>
      ),
    },
    {
      key: '3',
      label: 'App Development Frameworks/Libraries',
      children: (
        <div>
            <img src="https://img.shields.io/badge/Django-092E20?style=for-the-badge&logo=django&logoColor=green" alt="Django_badge" />
            <img src="https://img.shields.io/badge/Node.js-339933?style=for-the-badge&logo=nodedotjs&logoColor=white" alt="Node js_badge" />
            <img src="https://img.shields.io/badge/Express.js-000000?style=for-the-badge&logo=express&logoColor=white" alt="Express js_badge" />
            <img src="https://img.shields.io/badge/next.js-000000?style=for-the-badge&logo=nextdotjs&logoColor=white" alt="next js_badge" />
            <img src="https://img.shields.io/badge/Flask-000000?style=for-the-badge&logo=flask&logoColor=white" alt="Flask_badge" />
        </div>
      ),
    },
    {
      key: '4',
      label: 'Database',
      children: (
        <div>
            <img src="https://img.shields.io/badge/PostgreSQL-316192?style=for-the-badge&logo=postgresql&logoColor=white" alt="PostgreSQL_badge" />
            <img src="https://img.shields.io/badge/MySQL-005C84?style=for-the-badge&logo=mysql&logoColor=white" alt="MySQL_badge" />
            <img src="https://img.shields.io/badge/SQLite-07405E?style=for-the-badge&logo=sqlite&logoColor=white" alt="SQLite_badge" />
            <img src="https://img.shields.io/badge/Firebase-039BE5?style=for-the-badge&logo=Firebase&logoColor=orange" alt="Firebase_badge" />
        </div>
      ),
    },
    {
        key: '5',
        label: 'Deployment and Source Control',
        children: (
          <div>
            <img src="https://img.shields.io/badge/ubuntu-orange?style=for-the-badge&logo=ubuntu" alt="ubuntu_badge" />
            <img src="https://img.shields.io/badge/GitHub-100000?style=for-the-badge&logo=github&logoColor=white" alt="GitHub_badge" />
            <img src="https://img.shields.io/badge/Docker-2CA5E0?style=for-the-badge&logo=docker&logoColor=white" alt="Docker_badge" />
            <img src="https://img.shields.io/badge/GIT-E44C30?style=for-the-badge&logo=git&logoColor=white" alt="GIT_badge" />
            <img src="https://img.shields.io/badge/vercel-%23000000.svg?style=for-the-badge&logo=vercel&logoColor=white" alt="Vercel_badge" />
            <img src="https://img.shields.io/badge/nginx-%23009639.svg?style=for-the-badge&logo=nginx&logoColor=white" alt="Nginx_badge" />
            <img src="https://img.shields.io/badge/gunicorn-%298729.svg?style=for-the-badge&logo=gunicorn&logoColor=white" alt="Gunicorn_badge" />
            <img src="https://img.shields.io/badge/Firebase-039BE5?style=for-the-badge&logo=Firebase&logoColor=orange" alt="Firebase_badge" />
            <img src="https://img.shields.io/badge/sentry-pink?style=for-the-badge&logo=sentry" alt="sentry_badge"/>
            <img src="https://img.shields.io/badge/vim-black?style=for-the-badge&logo=vim" alt="vim" />
          </div>
        ),
      },
    {
      key: '6',
      label: 'Other Packages and Modules Used',
      children: (
        <div>
            <img src="https://img.shields.io/badge/-Swagger-%23Clojure?style=for-the-badge&logo=swagger&logoColor=white" alt="Swagger_badge" />
            <img src="https://img.shields.io/badge/Postman-FF6C37?style=for-the-badge&logo=postman&logoColor=white" alt="Postman_badge" />
            <img src="https://img.shields.io/badge/Firebase-039BE5?style=for-the-badge&logo=Firebase&logoColor=orange" alt="Firebase_badge" />
            <img src="https://img.shields.io/badge/pypdf2-green?style=for-the-badge&logo=pypdf2" alt="pypdf2_badge" />
            <img src="https://img.shields.io/badge/RabbitMQ-purple?style=for-the-badge&logo=RabbitMQ" alt="rabbit_badge" />

            
        </div>
      ),
    },
  ];